import type { BrandingType } from '@root/@types/types';

export const pickValidBrandingTemplates = (brandings: BrandingType[]) =>
  brandings.filter((b: BrandingType) => b.status === 'PUBLISHED');
